/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. It only explains the schedule. Parsing happens entirely in your browser; nothing is uploaded or executed.`)
};

const es_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Solo explica el horario. El análisis sucede completamente en tu navegador; nada se carga ni se ejecuta.`)
};

const de_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein. Es erklärt lediglich den Zeitplan. Die Verarbeitung erfolgt vollständig in Ihrem Browser; nichts wird hochgeladen oder ausgeführt.`)
};

const nl_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee. Het verklaart alleen het schema. Het parseren gebeurt volledig in uw browser; er wordt niets geupload of uitgevoerd.`)
};

const fr_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non. Il explique simplement l'horaire. L'analyse se fait entièrement dans votre navigateur ; rien n'est envoyé ou exécuté.`)
};

const it_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No. Spiega solo la pianificazione. L'analisi avviene interamente nel tuo browser; nulla viene caricato o eseguito.`)
};

const pt_br2_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Apenas explica o cronograma. A análise acontece totalmente no seu navegador; nada é enviado ou executado.`)
};

const pt_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não. Apenas explica o agendamento. A análise acontece completamente no seu navegador; nada é carregado ou executado.`)
};

const ja_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いいえ。スケジュールを説明するだけです。解析はすべてブラウザで行われ、何もアップロードまたは実行されません。`)
};

const zh_cr_faq3_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不会。它只会解释计划本身。解析完全在你的浏览器中进行，不会上传或执行任何内容。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cr_faq3_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cr_faq3_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cr_faq3_a", locale)
	if (locale === "en") return en_cr_faq3_a(inputs)
	if (locale === "es") return es_cr_faq3_a(inputs)
	if (locale === "de") return de_cr_faq3_a(inputs)
	if (locale === "nl") return nl_cr_faq3_a(inputs)
	if (locale === "fr") return fr_cr_faq3_a(inputs)
	if (locale === "it") return it_cr_faq3_a(inputs)
	if (locale === "pt-BR") return pt_br2_cr_faq3_a(inputs)
	if (locale === "pt") return pt_cr_faq3_a(inputs)
	if (locale === "ja") return ja_cr_faq3_a(inputs)
	return zh_cr_faq3_a(inputs)
};